import { h, render, createContext } from "preact";
import { useState, useEffect } from "preact/hooks";

import { useCookies } from "react-cookie";
import socket from "./socket";

const SessionContext = createContext([{}, () => { }]);

function anonymous_entries(url) {
	if (url.startsWith("/login") || url.startsWith("/devenir-vendeur") ||
		url.startsWith("/devenir-ambassadeur") || url.startsWith("/devenir-acquereur") ||
		url.startsWith("/publicpage/") || url.startsWith("/parrainage") || url.startsWith("/search")
		|| url.startsWith("/inscription") || url.startsWith("/lostpwd") || url.startsWith("/ambassadeurs") || url.startsWith("/nos_ambassadeurs")) {
		//if (["/login", "/devenir-vendeur", "/devenir-ambassadeur", "/devenir-acquereur", "/publicpage"].includes(url)) {
		return true;
	}
	if (url.startsWith("/t/")) {
		return true;
	}
	return false;
}


const SessionProvider = (props) => {

	const [cookies, setCookie] = useCookies();
	//const [cookies, setCookie] = useCookies(["_bkeys", "_bkuser"]);

	const [state, setState] = useState({ uid: cookies, conn: undefined, socket: undefined });

	//console.log("Render SessionProvider", cookies, props, window.location.href)

	useEffect(() => {
		//if (!anonymous_entries(location.pathname)) {
		fetch("/api/session")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				console.log("/api/session", res);
				switch (res.res) {
					case "ok":
						//		console.log("repky from /api/session", res)

						setState((state) => ({
							...state,
							name: res.profile ? res.profile.n : null,
							u: res.profile ? res.profile.u : null,
							role_a: res.profile ? res.profile.role_a : null,
							role_du: res.profile ? res.profile.role_du : null,
							conn: res.session,
							socket: socket

						}));



						break;
					case "err":
						setState((state) => ({
							...state,

							conn: false,


						}));
						break;
					default:
						break;
				}
			});
		// } else {
		// 	// setState((state) => ({
		// 	// 	...state, conn: false
		// 	// }));
		// }

	}, []);

	useEffect(() => {
		//	console.log("state is", state)

		setCookie("_bkuser", state.name, { path: "/" });
		setCookie("_bka", state.role_a, { path: "/" });
		setCookie("_bkdu", state.role_du, { path: "/" });
	}, [state])

	//console.log("session render", state.conn, window.location.href);
	if (state.conn === undefined) {
		return false;
	}
	if (state.conn === false && !anonymous_entries(location.pathname)) {
		console.log("redirecting to login *", location.pathname)
		window.location.href = "/login?r=" + location.pathname;
		return;
	}
	//console.log("renderSessionContext with conn ", state.conn)
	return (
		<SessionContext.Provider value={[state, setState]}>
			{props.children}
		</SessionContext.Provider>
	);
};

export { SessionContext, SessionProvider };
